export default __webpack_public_path__ + "static/media/saikrishna.cfc5b0b9.jpg";